// extracted by mini-css-extract-plugin
export var boldText = "_5w-4";
export var checkboxContainer = "_5w-6";
export var closeIcon = "_5w-i";
export var container = "_5w-0";
export var drawer = "_5w-8";
export var drawerContent = "_5w-9";
export var extraSmallText = "_5w-5";
export var fulfillmentGroupTable = "_5w-e";
export var largeText = "_5w-3";
export var loadingSpinnerContainer = "_5w-j";
export var mediumText = "_5w-2";
export var narrow = "_5w-f";
export var notificationLink = "_5w-l";
export var packageCheckIconContainer = "_5w-7";
export var slideoutHeaderActions = "_5w-g";
export var slideoutHeaderActionsShifted = "_5w-h";
export var slideoutHeaderContainer = "_5w-a";
export var slideoutModal = "_5w-c";
export var stickyHeaderWrapper = "_5w-b";
export var table = "_5w-k";
export var tableContainer = "_5w-d";
export var tertiaryText = "_5w-1";